import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ContactdetailsupdatePage} from '../contactdetailsupdate/contactdetailsupdate'
import {UpdateladlinenumberPage} from '../updateladlinenumber/updateladlinenumber'
import {UpdateofficialemailPage} from '../updateofficialemail/updateofficialemail'

/**
 * Generated class for the UpdatecontactPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-updatecontact',
  templateUrl: 'updatecontact.html',
})
export class UpdatecontactPage {
  contactDtailsData:any={};
  contactDtailsOfficeData:any={};
  ladline:any=''
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad UpdatecontactPage',this.navParams);
    this.contactDtailsData = this.navParams.data.addressDetail.responseParameters.filter((res:any)=>{
      return res.mailingaddress=="Y" && res.addresstype== "CURRES" && res.applicanttype=='Applicant'
    })[0];
    this.contactDtailsOfficeData = this.navParams.data.addressDetail.responseParameters.filter((res:any)=>{
      return  res.addresstype=='OFFICE' && res.applicanttype=='Applicant'
    })[0];
    this.ladline = this.contactDtailsOfficeData.stdcode+'-'+this.contactDtailsOfficeData.phone1
    //console.log(this.contactDtailsData,'contact data');

  }
  goToEditScreen(action,page){
    //console.log(action)
    if(!action){
      action={}
    }
    if(page=='RegisteredMobile'){
      this.navCtrl.push(ContactdetailsupdatePage,{queryParams:action});
    }else if(page=='ladline'){
      this.navCtrl.push(UpdateladlinenumberPage,{queryParams:action});
    }else if(page=='officialemail'){
      action.communication=false
      this.navCtrl.push(UpdateofficialemailPage,{queryParams:action});
    }else{
      action.communication=true
      this.navCtrl.push(UpdateofficialemailPage,{queryParams:action});
    }

    // this.navCtrl.push(UpdatepersonaleditPage,{queryParams:action});
  }

}



// WEBPACK FOOTER //
// ./src/pages/updatecontact/updatecontact.ts